import "./repo.a5e9c946.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecaa2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecaa2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lsboS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9e50e5a44fb11e0$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $f9e50e5a44fb11e0$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ArrowRight", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
]);

});

parcelRegister("gn8IX", function(module, exports) {

$parcel$export(module.exports, "default", () => $beb58fc2118025b6$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $beb58fc2118025b6$export$2e2bcd8739ae039 = (0, $b4WUK.default)("CalendarDays", [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ],
    [
        "path",
        {
            d: "M8 14h.01",
            key: "6423bh"
        }
    ],
    [
        "path",
        {
            d: "M12 14h.01",
            key: "1etili"
        }
    ],
    [
        "path",
        {
            d: "M16 14h.01",
            key: "1gbofw"
        }
    ],
    [
        "path",
        {
            d: "M8 18h.01",
            key: "lrp35t"
        }
    ],
    [
        "path",
        {
            d: "M12 18h.01",
            key: "mhygvu"
        }
    ],
    [
        "path",
        {
            d: "M16 18h.01",
            key: "kzsmim"
        }
    ]
]);

});

parcelRegister("ki04U", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec558c98a508af21$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $ec558c98a508af21$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Clock3", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "polyline",
        {
            points: "12 6 12 12 16.5 12",
            key: "1aq6pp"
        }
    ]
]);

});

parcelRegister("8Z597", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a8032150568403$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $68a8032150568403$export$2e2bcd8739ae039 = (0, $b4WUK.default)("HandHeart", [
    [
        "path",
        {
            d: "M11 14h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16",
            key: "1ifwr1"
        }
    ],
    [
        "path",
        {
            d: "m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
            key: "17abbs"
        }
    ],
    [
        "path",
        {
            d: "m2 15 6 6",
            key: "10dquu"
        }
    ],
    [
        "path",
        {
            d: "M19.5 8.5c.7-.7 1.5-1.6 1.5-2.7A2.73 2.73 0 0 0 16 4a2.78 2.78 0 0 0-5 1.8c0 1.2.8 2 1.5 2.8L16 12Z",
            key: "1h3036"
        }
    ]
]);

});

parcelRegister("8dk79", function(module, exports) {

$parcel$export(module.exports, "default", () => $5faf23ec0b8e3e8e$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $5faf23ec0b8e3e8e$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Sparkles", [
    [
        "path",
        {
            d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
            key: "4pj2yx"
        }
    ],
    [
        "path",
        {
            d: "M20 3v4",
            key: "1olli1"
        }
    ],
    [
        "path",
        {
            d: "M22 5h-4",
            key: "1gvqau"
        }
    ],
    [
        "path",
        {
            d: "M4 17v2",
            key: "vumght"
        }
    ],
    [
        "path",
        {
            d: "M5 18H3",
            key: "zchphs"
        }
    ]
]);

});

parcelRegister("gRgf3", function(module, exports) {

$parcel$export(module.exports, "PageHero", () => $5405cac3ced8ac70$export$4b2976b57d220ac6);

var $ayMG0 = parcelRequire("ayMG0");
function $5405cac3ced8ac70$export$4b2976b57d220ac6({ kicker: kicker, title: title, lead: lead, image: image, imageAlt: imageAlt = '', children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "page-hero",
        children: [
            image && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page-hero-media",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: image,
                        alt: imageAlt
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "page-hero-overlay"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page-shell page-hero-content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "eyebrow eyebrow-light reveal is-visible",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-hidden": "true"
                            }),
                            " ",
                            kicker
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "reveal is-visible",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "page-hero-lead reveal is-visible",
                        children: lead
                    }),
                    children && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "page-hero-extra reveal is-visible",
                        children: children
                    })
                ]
            })
        ]
    });
}

});


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");

var $ayMG0 = parcelRequire("ayMG0");

var $lsboS = parcelRequire("lsboS");
var $03hdr = parcelRequire("03hdr");
var $gn8IX = parcelRequire("gn8IX");
var $ki04U = parcelRequire("ki04U");
var $8Z597 = parcelRequire("8Z597");/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $bfcb8924c7a113d6$export$2e2bcd8739ae039 = (0, $b4WUK.default)("HeartHandshake", [
    [
        "path",
        {
            d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
            key: "c3ymky"
        }
    ],
    [
        "path",
        {
            d: "M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66",
            key: "4oyue0"
        }
    ],
    [
        "path",
        {
            d: "m18 15-2-2",
            key: "60u0ii"
        }
    ],
    [
        "path",
        {
            d: "m15 18-2-2",
            key: "6p76be"
        }
    ]
]);


var $hipFw = parcelRequire("hipFw");/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $b35b87dba8702d35$export$2e2bcd8739ae039 = (0, $b4WUK.default)("MessageCircleHeart", [
    [
        "path",
        {
            d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z",
            key: "vv11sd"
        }
    ],
    [
        "path",
        {
            d: "M15.8 9.2a2.5 2.5 0 0 0-3.5 0l-.3.4-.35-.3a2.42 2.42 0 1 0-3.2 3.6l3.6 3.5 3.6-3.5c1.2-1.2 1.1-2.7.2-3.7",
            key: "43lnbm"
        }
    ]
]);


var $8dk79 = parcelRequire("8dk79");

var $clpju = parcelRequire("clpju");

var $5xqgC = parcelRequire("5xqgC");

var $gRgf3 = parcelRequire("gRgf3");

var $3ua1s = parcelRequire("3ua1s");

var $gb7Gf = parcelRequire("gb7Gf");
const $42bcd165bccb90fa$var$expectations = [
    {
        icon: (0, $bfcb8924c7a113d6$export$2e2bcd8739ae039),
        number: '01',
        title: 'Te recibimos como familia',
        text: "Desde la puerta alguien te dar\xe1 la bienvenida y te ayudar\xe1 a encontrar tu lugar. Ven tal como eres."
    },
    {
        icon: (0, $8dk79.default),
        number: '02',
        title: "Adoraci\xf3n y Palabra",
        text: "Vivimos un tiempo de alabanza genuina y un mensaje b\xedblico, pr\xe1ctico y lleno de esperanza."
    },
    {
        icon: (0, $8Z597.default),
        number: '03',
        title: 'Oramos por ti',
        text: "Al final de cada servicio hay un momento para orar. Si lo deseas, te acompa\xf1amos en oraci\xf3n."
    }
];
const $42bcd165bccb90fa$var$faqs = [
    {
        question: "\xbfTengo que vestir de alguna forma especial?",
        answer: "No. Ven como te sientas c\xf3modo: en la casa encontrar\xe1s personas de todo estilo. Lo importante es que vengas."
    },
    {
        question: "\xbfPuedo llevar a mis hijos?",
        answer: "\xa1Claro! Los ni\xf1os son bienvenidos en todos nuestros servicios. Trae a toda la familia, hay un lugar para cada uno."
    },
    {
        question: "\xbfNecesito ser miembro o registrarme para asistir?",
        answer: "No necesitas registrarte ni ser miembro. Todos nuestros servicios son abiertos; llega unos minutos antes y si\xe9ntete en casa."
    },
    {
        question: "\xbfCu\xe1nto dura un servicio?",
        answer: "Aproximadamente hora y media. Incluye adoraci\xf3n, el mensaje y un momento de oraci\xf3n al final."
    }
];
function $42bcd165bccb90fa$var$NextServiceBanner() {
    const next = (0, $3ua1s.useNextService)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "next-service-banner reveal",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "pulse-dot",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                children: [
                    "Pr\xf3ximo encuentro: ",
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                        children: [
                            next.service.day,
                            " ",
                            next.service.time
                        ]
                    }),
                    " \xb7 ",
                    next.service.title
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "next-service-countdown",
                children: [
                    next.when,
                    " \xb7 ",
                    next.countdown
                ]
            })
        ]
    });
}
function $42bcd165bccb90fa$export$edcd812814f1ccb7() {
    (0, $3ua1s.useReveal)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5xqgC.Layout), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gRgf3.PageHero), {
                kicker: "Planifica tu visita",
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Tu primera visita, ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                            children: "sin complicaciones"
                        }),
                        "."
                    ]
                }),
                lead: "Queremos que llegar por primera vez se sienta sencillo. Aqu\xed tienes todo lo que necesitas: qu\xe9 esperar, horarios y c\xf3mo llegar.",
                image: (0, $clpju.imgCongregacionWide),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                    className: "button button-gold",
                    href: (0, $gb7Gf.mapUrl),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: [
                        "Abrir en Google Maps ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                            size: 18,
                            "aria-hidden": "true"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "section-space",
                "aria-labelledby": "expect-title",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "page-shell",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "section-heading reveal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "section-kicker",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                                " Qu\xe9 esperar"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            id: "expect-title",
                                            children: "As\xed se siente un domingo con nosotros."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "Un ambiente cercano, sin protocolos complicados. Llega como est\xe1s; nosotros ponemos la bienvenida."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "expect-grid",
                            children: $42bcd165bccb90fa$var$expectations.map(({ icon: Icon, number: number, title: title, text: text })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("article", {
                                    className: "visit-step reveal",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "step-topline",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "step-icon",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                                        size: 22,
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "step-number",
                                                    children: number
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: text
                                        })
                                    ]
                                }, number))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "visit-schedule section-space",
                "aria-labelledby": "schedule-title",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "page-shell",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "section-heading reveal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "section-kicker",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                                " Horarios"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            id: "schedule-title",
                                            children: "Elige tu encuentro."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($42bcd165bccb90fa$var$NextServiceBanner, {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "schedule-list",
                            children: (0, $gb7Gf.services).map((service)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("article", {
                                    className: "schedule-row reveal",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "schedule-day",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gn8IX.default), {
                                                    size: 20,
                                                    "aria-hidden": "true"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: service.day
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("time", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ki04U.default), {
                                                    size: 18,
                                                    "aria-hidden": "true"
                                                }),
                                                " ",
                                                service.time
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "schedule-info",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    children: service.title
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: service.note
                                                })
                                            ]
                                        })
                                    ]
                                }, `${service.day}-${service.time}`))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "section-space",
                "aria-labelledby": "location-title",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "page-shell location-layout",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "location-copy reveal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "section-kicker",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                        " C\xf3mo llegar"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    id: "location-title",
                                    children: "Estamos en el coraz\xf3n de Ju\xe1rez."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "Abre la ruta antes de salir y llega unos minutos antes del servicio. Te esperamos con la puerta abierta."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    className: "visit-detail visit-detail-link",
                                    href: (0, $gb7Gf.mapUrl),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hipFw.default), {
                                                size: 21,
                                                "aria-hidden": "true"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                    children: "Direcci\xf3n"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: (0, $gb7Gf.churchAddress).street
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    children: (0, $gb7Gf.churchAddress).locality
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                                            className: "visit-detail-arrow",
                                            size: 18,
                                            "aria-hidden": "true"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    className: "button button-primary",
                                    href: (0, $gb7Gf.mapUrl),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: [
                                        "C\xf3mo llegar ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                                            size: 18,
                                            "aria-hidden": "true"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "location-map reveal",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                title: "Mapa de Iglesia Cristiana Tercer Cielo",
                                src: (0, $gb7Gf.mapEmbedUrl),
                                loading: "lazy",
                                referrerPolicy: "no-referrer-when-downgrade",
                                allowFullScreen: true
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "faq-section section-space",
                "aria-labelledby": "faq-title",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "page-shell faq-layout",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "faq-intro reveal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "section-kicker",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                        " Preguntas frecuentes"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    id: "faq-title",
                                    children: "\xbfPrimera vez? Tranquilo."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    children: [
                                        "Estas son las preguntas que m\xe1s nos hacen quienes nos visitan por primera vez. Si tienes otra, ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            className: "text-link",
                                            href: "/contacto/",
                                            children: "escr\xedbenos"
                                        }),
                                        "."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "faq-list",
                            children: $42bcd165bccb90fa$var$faqs.map((faq)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("details", {
                                    className: "faq-item reveal",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("summary", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b35b87dba8702d35$export$2e2bcd8739ae039), {
                                                    size: 20,
                                                    "aria-hidden": "true"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    children: faq.question
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "faq-chevron",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: faq.answer
                                        })
                                    ]
                                }, faq.question))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "cta-band",
                "aria-labelledby": "visit-cta-title",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "page-shell cta-band-inner reveal",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            id: "visit-cta-title",
                            children: [
                                "Nos vemos este ",
                                (0, $gb7Gf.services)[0].day,
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "Guarda la direcci\xf3n, elige tu horario y ven a casa."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "cta-band-actions",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    className: "button button-light",
                                    href: (0, $gb7Gf.mapUrl),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: [
                                        "Abrir en Google Maps ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                                            size: 18,
                                            "aria-hidden": "true"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    className: "button button-ghost",
                                    href: "/contacto/",
                                    children: [
                                        "Escr\xedbenos ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lsboS.default), {
                                            size: 18,
                                            "aria-hidden": "true"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}



const $d4a05ec32aefc256$var$container = document.getElementById('app');
(0, $aRPiL.createRoot)($d4a05ec32aefc256$var$container).render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.StrictMode), {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $42bcd165bccb90fa$export$edcd812814f1ccb7), {})
}));


//# sourceMappingURL=visita.e9b6a43b.js.map
